const LS_PREFIX = 'mdv-unified-panel-dock';

function storageKey(projectName) {
  return `${LS_PREFIX}:${String(projectName || 'default')}`;
}

const DEFAULT = {
  docked: true,
  collapsed: false,
  width: 320,
  side: 'left',
};

export const DOCK_EDGE_PX = 36;

export function normalizeDockSide(side) {
  return side === 'right' ? 'right' : 'left';
}

/** Snap zone at the far left/right of the screen while dragging the floating panel. */
export function resolveDockSideFromDrag({ clientX, left, originLeft } = {}) {
  const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
  if (!vw) return null;
  const towardLeft = typeof originLeft !== 'number' || left < originLeft - 4;
  const towardRight = typeof originLeft !== 'number' || left > originLeft + 4;
  if (typeof clientX === 'number') {
    if (towardLeft && clientX <= DOCK_EDGE_PX) return 'left';
    if (towardRight && clientX >= vw - DOCK_EDGE_PX) return 'right';
  }
  if (typeof left === 'number') {
    if (towardLeft && left <= DOCK_EDGE_PX) return 'left';
    if (towardRight && left >= vw - 56) return 'right';
  }
  return null;
}

export function readUnifiedPanelDock(projectName) {
  try {
    const raw = localStorage.getItem(storageKey(projectName));
    if (!raw) return { ...DEFAULT };
    const data = JSON.parse(raw);
    if (!data || typeof data !== 'object') return { ...DEFAULT };
    return {
      docked: Boolean(data.docked),
      collapsed: Boolean(data.collapsed),
      width: typeof data.width === 'number' && data.width >= 260 ? data.width : DEFAULT.width,
      side: normalizeDockSide(data.side),
    };
  } catch {
    return { ...DEFAULT };
  }
}

export function writeUnifiedPanelDock(projectName, patch) {
  try {
    const prev = readUnifiedPanelDock(projectName);
    localStorage.setItem(
      storageKey(projectName),
      JSON.stringify({
        ...prev,
        ...patch,
        savedAt: new Date().toISOString(),
      })
    );
  } catch {
    // quota or private mode
  }
}
